import React from 'react'
import { Link } from 'react-router-dom';

function Adminheader() {
  return (
    <div>
         <div id="mimin" class="dashboard">
        <nav className="navbar1 navbar-default header navbar-fixed-top">
          <div className="col-md-12 nav-wrapper">
            <div className="navbar-header">
              <Link to="/admin" className="navbar-brand">
                <b>HR School</b>
              </Link>
              <ul className="nav navbar-nav search-nav">
                <li>
                  <div className="search">
                    <span className="fa fa-search icon-search" />
                    <div className="form-group form-animate-text">
                      <input type="text" className="form-text" required />
                      <span className="bar" />
                      <label className="label-search">
                        Type anywhere to <b>Search</b>{" "}
                      </label>
                    </div>
                  </div>
                </li>
              </ul>
             
              <ul className="nav navbar-nav search-nav hero">
                <li className="user-name">
                  <span>Hero Gaur</span>
                </li>
                <li className="dropdown avatar-dropdown">
                  {/* <img
                    src="assets/imgs/avatar.jpeg"
                    className="img-circle avatar"
                    alt="user name" 
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="true"
                  /> */}
                  <ul className="dropdown-menu user-dropdown">
                    <li>
                      <Link to="/profile">
                        <span className="fa fa-user" /> My Profile
                      </Link>
                    </li>
                    <li role="separator" className="divider" />
                    <li className="more">
                      <ul>
                        <li>
                          <Link to="/">
                            <span className="fa fa-power-off " />
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Adminheader